//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['unit'],
    data: function data() {
        return {
            loading: true,
            unitData: {},
            unitResidents: []
        };
    },

    computed: {},
    watch: {},
    created: function created() {
        var _this = this;

        Event.$on('load-unit-summary', function (unit) {
            if (unit) {
                _this.unitData = unit;
                // console.log($el.unitData)
                _this.unitResidents = unit.residents;
                _this.loading = false;
            }
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('load-unit-summary');
    },

    methods: {
        isCurrent: function isCurrent(resident) {
            if (!resident.move_out_date) {
                // console.log("test")
                return true;
            } else {
                var today = new Date();
                var inputDate = new Date(resident.move_out_date);

                // console.log(inputDate.toDateString())

                if (inputDate.getTime() >= today.getTime()) {
                    return true;
                }

                return false;
            }

            return false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/UnitSummary.vue
// module id = uEGt
// module chunks = 0 1